// Philippine geographic dataset (PSGC 2019v2) — Region -> Province -> Cities/Municipalities.
// Source: flores-jacob/philippine-regions-provinces-cities-municipalities-barangays.
// Used by ContactModal address cascade (Region -> Province -> City). Do not hand-edit.
export const PH_GEO = {
  "National Capital Region (NCR)": {
    "Metro Manila": [
      "City of Manila",
      "Quezon City",
      "Caloocan City",
      "Las Piñas City",
      "Makati City",
      "Malabon City",
      "Mandaluyong City",
      "Marikina City",
      "Muntinlupa City",
      "Navotas City",
      "Parañaque City",
      "Pasay City",
      "Pasig City",
      "San Juan City",
      "Taguig City",
      "Valenzuela City",
      "Pateros"
    ]
  },
  "Cordillera Administrative Region (CAR)": {
    "Abra": [
      "Bangued",
      "Boliney",
      "Bucay",
      "Bucloc",
      "Daguioman",
      "Danglas",
      "Dolores",
      "La Paz",
      "Lacub",
      "Lagangilang",
      "Lagayan",
      "Langiden",
      "Licuan-Baay (licuan)",
      "Luba",
      "Malibcong",
      "Manabo",
      "Peñarrubia",
      "Pidigan",
      "Pilar",
      "Sallapadan",
      "San Isidro",
      "San Juan",
      "San Quintin",
      "Tayum",
      "Tineg",
      "Tubo",
      "Villaviciosa"
    ],
    "Apayao": [
      "Calanasan (bayag)",
      "Conner",
      "Flora",
      "Kabugao",
      "Luna",
      "Pudtol",
      "Santa Marcela"
    ],
    "Benguet": [
      "Atok",
      "Baguio City",
      "Bakun",
      "Bokod",
      "Buguias",
      "Itogon",
      "Kabayan",
      "Kapangan",
      "Kibungan",
      "La Trinidad",
      "Mankayan",
      "Sablan",
      "Tuba",
      "Tublay"
    ],
    "Ifugao": [
      "Aguinaldo",
      "Alfonso Lista (potia)",
      "Asipulo",
      "Banaue",
      "Hingyon",
      "Hungduan",
      "Kiangan",
      "Lagawe",
      "Lamut",
      "Mayoyao",
      "Tinoc"
    ],
    "Kalinga": [
      "Balbalan",
      "Lubuagan",
      "Pasil",
      "Pinukpuk",
      "Rizal (liwan)",
      "Tabuk City",
      "Tanudan",
      "Tinglayan"
    ],
    "Mountain Province": [
      "Barlig",
      "Bauko",
      "Besao",
      "Bontoc",
      "Natonin",
      "Paracelis",
      "Sabangan",
      "Sadanga",
      "Sagada",
      "Tadian"
    ]
  },
  "Region I – Ilocos Region": {
    "Ilocos Norte": [
      "Adams",
      "Bacarra",
      "Badoc",
      "Bangui",
      "Banna (espiritu)",
      "Batac City",
      "Burgos",
      "Carasi",
      "Currimao",
      "Dingras",
      "Dumalneg",
      "Laoag City",
      "Marcos",
      "Nueva Era",
      "Pagudpud",
      "Paoay",
      "Pasuquin",
      "Piddig",
      "Pinili",
      "San Nicolas",
      "Sarrat",
      "Solsona",
      "Vintar"
    ],
    "Ilocos Sur": [
      "Alilem",
      "Banayoyo",
      "Bantay",
      "Burgos",
      "Cabugao",
      "Candon City",
      "Caoayan",
      "Cervantes",
      "Galimuyod",
      "Gregorio del Pilar (concepcion)",
      "Lidlidda",
      "Magsingal",
      "Nagbukel",
      "Narvacan",
      "Quirino (angkaki)",
      "Salcedo (baugen)",
      "San Emilio",
      "San Esteban",
      "San Ildefonso",
      "San Juan (lapog)",
      "San Vicente",
      "Santa",
      "Santa Catalina",
      "Santa Cruz",
      "Santa Lucia",
      "Santa Maria",
      "Santiago",
      "Santo Domingo",
      "Sigay",
      "Sinait",
      "Sugpon",
      "Suyo",
      "Tagudin",
      "Vigan City"
    ],
    "La Union": [
      "Agoo",
      "Aringay",
      "Bacnotan",
      "Bagulin",
      "Balaoan",
      "Bangar",
      "Bauang",
      "Burgos",
      "Caba",
      "City of San Fernando",
      "Luna",
      "Naguilian",
      "Pugo",
      "Rosario",
      "San Gabriel",
      "San Juan",
      "Santo Tomas",
      "Santol",
      "Sudipen",
      "Tubao"
    ],
    "Pangasinan": [
      "Agno",
      "Aguilar",
      "Alaminos City",
      "Alcala",
      "Anda",
      "Asingan",
      "Balungao",
      "Bani",
      "Basista",
      "Bautista",
      "Bayambang",
      "Binalonan",
      "Binmaley",
      "Bolinao",
      "Bugallon",
      "Burgos",
      "Calasiao",
      "Dagupan City",
      "Dasol",
      "Infanta",
      "Labrador",
      "Laoac",
      "Lingayen",
      "Mabini",
      "Malasiqui",
      "Manaoag",
      "Mangaldan",
      "Mangatarem",
      "Mapandan",
      "Natividad",
      "Pozorrubio",
      "Rosales",
      "San Carlos City",
      "San Fabian",
      "San Jacinto",
      "San Manuel",
      "San Nicolas",
      "San Quintin",
      "Santa Barbara",
      "Santa Maria",
      "Santo Tomas",
      "Sison",
      "Sual",
      "Tayug",
      "Umingan",
      "Urbiztondo",
      "Urdaneta City",
      "Villasis"
    ]
  },
  "Region II – Cagayan Valley": {
    "Batanes": [
      "Basco",
      "Itbayat",
      "Ivana",
      "Mahatao",
      "Sabtang",
      "Uyugan"
    ],
    "Cagayan": [
      "Abulug",
      "Alcala",
      "Allacapan",
      "Amulung",
      "Aparri",
      "Baggao",
      "Ballesteros",
      "Buguey",
      "Calayan",
      "Camalaniugan",
      "Claveria",
      "Enrile",
      "Gattaran",
      "Gonzaga",
      "Iguig",
      "Lal-Lo",
      "Lasam",
      "Pamplona",
      "Peñablanca",
      "Piat",
      "Rizal",
      "Sanchez-Mira",
      "Santa Ana",
      "Santa Praxedes",
      "Santa Teresita",
      "Santo Niño (faire)",
      "Solana",
      "Tuao",
      "Tuguegarao City"
    ],
    "Isabela": [
      "Alicia",
      "Angadanan",
      "Aurora",
      "Benito Soliven",
      "Burgos",
      "Cabagan",
      "Cabatuan",
      "Cauayan City",
      "City of Santiago",
      "Cordon",
      "Delfin Albano (magsaysay)",
      "Dinapigue",
      "Divilacan",
      "Echague",
      "Gamu",
      "Ilagan City",
      "Jones",
      "Luna",
      "Maconacon",
      "Mallig",
      "Naguilian",
      "Palanan",
      "Quezon",
      "Quirino",
      "Ramon",
      "Reina Mercedes",
      "Roxas",
      "San Agustin",
      "San Guillermo",
      "San Isidro",
      "San Manuel",
      "San Mariano",
      "San Mateo",
      "San Pablo",
      "Santa Maria",
      "Santo Tomas",
      "Tumauini"
    ],
    "Nueva Vizcaya": [
      "Alfonso Castaneda",
      "Ambaguio",
      "Aritao",
      "Bagabag",
      "Bambang",
      "Bayombong",
      "Diadi",
      "Dupax del Norte",
      "Dupax del Sur",
      "Kasibu",
      "Kayapa",
      "Quezon",
      "Santa Fe",
      "Solano",
      "Villaverde"
    ],
    "Quirino": [
      "Aglipay",
      "Cabarroguis",
      "Diffun",
      "Maddela",
      "Nagtipunan",
      "Saguday"
    ]
  },
  "Region III – Central Luzon": {
    "Aurora": [
      "Baler",
      "Casiguran",
      "Dilasag",
      "Dinalungan",
      "Dingalan",
      "Dipaculao",
      "Maria Aurora",
      "San Luis"
    ],
    "Bataan": [
      "Abucay",
      "Bagac",
      "Balanga City",
      "Dinalupihan",
      "Hermosa",
      "Limay",
      "Mariveles",
      "Morong",
      "Orani",
      "Orion",
      "Pilar",
      "Samal"
    ],
    "Bulacan": [
      "Angat",
      "Balagtas (bigaa)",
      "Baliuag",
      "Bocaue",
      "Bulacan",
      "Bustos",
      "Calumpit",
      "Doña Remedios Trinidad",
      "Guiguinto",
      "Hagonoy",
      "Malolos City",
      "Marilao",
      "Meycauayan City",
      "Norzagaray",
      "Obando",
      "Pandi",
      "Paombong",
      "Plaridel",
      "Pulilan",
      "San Ildefonso",
      "San Jose del Monte City",
      "San Miguel",
      "San Rafael",
      "Santa Maria"
    ],
    "Nueva Ecija": [
      "Aliaga",
      "Bongabon",
      "Cabanatuan City",
      "Cabiao",
      "Carranglan",
      "Cuyapo",
      "Gabaldon (bitulok and Sabani)",
      "Gapan City",
      "General Mamerto Natividad",
      "General Tinio (papaya)",
      "Guimba",
      "Jaen",
      "Laur",
      "Licab",
      "Llanera",
      "Lupao",
      "Nampicuan",
      "Palayan City",
      "Pantabangan",
      "Peñaranda",
      "Quezon",
      "Rizal",
      "San Antonio",
      "San Isidro",
      "San Jose City",
      "San Leonardo",
      "Santa Rosa",
      "Santo Domingo",
      "Science City of Muñoz",
      "Talavera",
      "Talugtug",
      "Zaragoza"
    ],
    "Pampanga": [
      "Angeles City",
      "Apalit",
      "Arayat",
      "Bacolor",
      "Candaba",
      "Floridablanca",
      "Guagua",
      "Lubao",
      "Mabalacat City",
      "Macabebe",
      "Magalang",
      "Masantol",
      "Mexico",
      "Minalin",
      "Porac",
      "San Fernando City",
      "San Luis",
      "San Simon",
      "Santa Ana",
      "Santa Rita",
      "Santo Tomas",
      "Sasmuan (sexmoan)"
    ],
    "Tarlac": [
      "Anao",
      "Bamban",
      "Camiling",
      "Capas",
      "City of Tarlac",
      "Concepcion",
      "Gerona",
      "La Paz",
      "Mayantoc",
      "Moncada",
      "Paniqui",
      "Pura",
      "Ramos",
      "San Clemente",
      "San Jose",
      "San Manuel",
      "Santa Ignacia",
      "Victoria"
    ],
    "Zambales": [
      "Botolan",
      "Cabangan",
      "Candelaria",
      "Castillejos",
      "Iba",
      "Masinloc",
      "Olongapo City",
      "Palauig",
      "San Antonio",
      "San Felipe",
      "San Marcelino",
      "San Narciso",
      "Santa Cruz",
      "Subic"
    ]
  },
  "Region IV-A – CALABARZON": {
    "Batangas": [
      "Agoncillo",
      "Alitagtag",
      "Balayan",
      "Balete",
      "Batangas City",
      "Bauan",
      "Calaca",
      "Calatagan",
      "Cuenca",
      "Ibaan",
      "Laurel",
      "Lemery",
      "Lian",
      "Lipa City",
      "Lobo",
      "Mabini",
      "Malvar",
      "Mataas Na Kahoy",
      "Nasugbu",
      "Padre Garcia",
      "Rosario",
      "San Jose",
      "San Juan",
      "San Luis",
      "San Nicolas",
      "San Pascual",
      "Santa Teresita",
      "Santo Tomas",
      "Taal",
      "Talisay",
      "Tanauan City",
      "Taysan",
      "Tingloy",
      "Tuy"
    ],
    "Cavite": [
      "Alfonso",
      "Amadeo",
      "Bacoor City",
      "Carmona",
      "Cavite City",
      "Dasmariñas City",
      "Gen. Mariano Alvarez",
      "General Emilio Aguinaldo",
      "General Trias City",
      "Imus City",
      "Indang",
      "Kawit",
      "Magallanes",
      "Maragondon",
      "Mendez (mendez-Nuñez)",
      "Naic",
      "Noveleta",
      "Rosario",
      "Silang",
      "Tagaytay City",
      "Tanza",
      "Ternate",
      "Trece Martires City"
    ],
    "Laguna": [
      "Alaminos",
      "Bay",
      "Cabuyao City",
      "Calamba City",
      "Calauan",
      "Cavinti",
      "City of Biñan",
      "Famy",
      "Kalayaan",
      "Liliw",
      "Los Baños",
      "Luisiana",
      "Lumban",
      "Mabitac",
      "Magdalena",
      "Majayjay",
      "Nagcarlan",
      "Paete",
      "Pagsanjan",
      "Pakil",
      "Pangil",
      "Pila",
      "Rizal",
      "San Pablo City",
      "San Pedro City",
      "Santa Cruz",
      "Santa Maria",
      "Santa Rosa City",
      "Siniloan",
      "Victoria"
    ],
    "Quezon": [
      "Agdangan",
      "Alabat",
      "Atimonan",
      "Buenavista",
      "Burdeos",
      "Calauag",
      "Candelaria",
      "Catanauan",
      "Dolores",
      "General Luna",
      "General Nakar",
      "Guinayangan",
      "Gumaca",
      "Infanta",
      "Jomalig",
      "Lopez",
      "Lucban",
      "Lucena City",
      "Macalelon",
      "Mauban",
      "Mulanay",
      "Padre Burgos",
      "Pagbilao",
      "Panukulan",
      "Patnanungan",
      "Perez",
      "Pitogo",
      "Plaridel",
      "Polillo",
      "Quezon",
      "Real",
      "Sampaloc",
      "San Andres",
      "San Antonio",
      "San Francisco (aurora)",
      "San Narciso",
      "Sariaya",
      "Tagkawayan",
      "Tayabas City",
      "Tiaong",
      "Unisan"
    ],
    "Rizal": [
      "Angono",
      "Baras",
      "Binangonan",
      "Cainta",
      "Cardona",
      "City of Antipolo",
      "Jala-Jala",
      "Morong",
      "Pililla",
      "Rodriguez (montalban)",
      "San Mateo",
      "Tanay",
      "Taytay",
      "Teresa"
    ]
  },
  "Region IV-B – MIMAROPA": {
    "Marinduque": [
      "Boac",
      "Buenavista",
      "Gasan",
      "Mogpog",
      "Santa Cruz",
      "Torrijos"
    ],
    "Occidental Mindoro": [
      "Abra de Ilog",
      "Calintaan",
      "Looc",
      "Lubang",
      "Magsaysay",
      "Mamburao",
      "Paluan",
      "Rizal",
      "Sablayan",
      "San Jose",
      "Santa Cruz"
    ],
    "Oriental Mindoro": [
      "Baco",
      "Bansud",
      "Bongabong",
      "Bulalacao (san Pedro)",
      "City of Calapan",
      "Gloria",
      "Mansalay",
      "Naujan",
      "Pinamalayan",
      "Pola",
      "Puerto Galera",
      "Roxas",
      "San Teodoro",
      "Socorro",
      "Victoria"
    ],
    "Palawan": [
      "Aborlan",
      "Agutaya",
      "Araceli",
      "Balabac",
      "Bataraza",
      "Brooke's Point",
      "Busuanga",
      "Cagayancillo",
      "Coron",
      "Culion",
      "Cuyo",
      "Dumaran",
      "El Nido (bacuit)",
      "Kalayaan",
      "Linapacan",
      "Magsaysay",
      "Narra",
      "Puerto Princesa City",
      "Quezon",
      "Rizal (marcos)",
      "Roxas",
      "San Vicente",
      "Sofronio Española",
      "Taytay"
    ],
    "Romblon": [
      "Alcantara",
      "Banton",
      "Cajidiocan",
      "Calatrava",
      "Concepcion",
      "Corcuera",
      "Ferrol",
      "Looc",
      "Magdiwang",
      "Odiongan",
      "Romblon",
      "San Agustin",
      "San Andres",
      "San Fernando",
      "San Jose",
      "Santa Fe",
      "Santa Maria (imelda)"
    ]
  },
  "Region V – Bicol Region": {
    "Albay": [
      "Bacacay",
      "Camalig",
      "City of Ligao",
      "Daraga (locsin)",
      "Guinobatan",
      "Jovellar",
      "Legazpi City",
      "Libon",
      "Malilipot",
      "Malinao",
      "Manito",
      "Oas",
      "Pio Duran",
      "Polangui",
      "Rapu-Rapu",
      "Santo Domingo (libog)",
      "Tabaco City",
      "Tiwi"
    ],
    "Camarines Norte": [
      "Basud",
      "Capalonga",
      "Daet",
      "Jose Panganiban",
      "Labo",
      "Mercedes",
      "Paracale",
      "San Lorenzo Ruiz (imelda)",
      "San Vicente",
      "Santa Elena",
      "Talisay",
      "Vinzons"
    ],
    "Camarines Sur": [
      "Baao",
      "Balatan",
      "Bato",
      "Bombon",
      "Buhi",
      "Bula",
      "Cabusao",
      "Calabanga",
      "Camaligan",
      "Canaman",
      "Caramoan",
      "Del Gallego",
      "Gainza",
      "Garchitorena",
      "Goa",
      "Iriga City",
      "Lagonoy",
      "Libmanan",
      "Lupi",
      "Magarao",
      "Milaor",
      "Minalabac",
      "Nabua",
      "Naga City",
      "Ocampo",
      "Pamplona",
      "Pasacao",
      "Pili",
      "Presentacion (parubcan)",
      "Ragay",
      "Sagñay",
      "San Fernando",
      "San Jose",
      "Sipocot",
      "Siruma",
      "Tigaon",
      "Tinambac"
    ],
    "Catanduanes": [
      "Bagamanoc",
      "Baras",
      "Bato",
      "Caramoran",
      "Gigmoto",
      "Pandan",
      "Panganiban (payo)",
      "San Andres (calolbon)",
      "San Miguel",
      "Viga",
      "Virac"
    ],
    "Masbate": [
      "Aroroy",
      "Baleno",
      "Balud",
      "Batuan",
      "Cataingan",
      "Cawayan",
      "Claveria",
      "Dimasalang",
      "Esperanza",
      "Mandaon",
      "Masbate City",
      "Milagros",
      "Mobo",
      "Monreal",
      "Palanas",
      "Pio V. Corpuz (limbuhan)",
      "Placer",
      "San Fernando",
      "San Jacinto",
      "San Pascual",
      "Uson"
    ],
    "Sorsogon": [
      "Barcelona",
      "Bulan",
      "Bulusan",
      "Casiguran",
      "Castilla",
      "Donsol",
      "Gubat",
      "Irosin",
      "Juban",
      "Magallanes",
      "Matnog",
      "Pilar",
      "Prieto Diaz",
      "Santa Magdalena",
      "Sorsogon City"
    ]
  },
  "Region VI – Western Visayas": {
    "Aklan": [
      "Altavas",
      "Balete",
      "Banga",
      "Batan",
      "Buruanga",
      "Ibajay",
      "Kalibo",
      "Lezo",
      "Libacao",
      "Madalag",
      "Makato",
      "Malay",
      "Malinao",
      "Nabas",
      "New Washington",
      "Numancia",
      "Tangalan"
    ],
    "Antique": [
      "Anini-Y",
      "Barbaza",
      "Belison",
      "Bugasong",
      "Caluya",
      "Culasi",
      "Hamtic",
      "Laua-An",
      "Libertad",
      "Pandan",
      "Patnongon",
      "San Jose",
      "San Remigio",
      "Sebaste",
      "Sibalom",
      "Tibiao",
      "Tobias Fornier (dao)",
      "Valderrama"
    ],
    "Capiz": [
      "Cuartero",
      "Dao",
      "Dumalag",
      "Dumarao",
      "Ivisan",
      "Jamindan",
      "Ma-Ayon",
      "Mambusao",
      "Panay",
      "Panitan",
      "Pilar",
      "Pontevedra",
      "President Roxas",
      "Roxas City",
      "Sapi-An",
      "Sigma",
      "Tapaz"
    ],
    "Guimaras": [
      "Buenavista",
      "Jordan",
      "Nueva Valencia",
      "San Lorenzo",
      "Sibunag"
    ],
    "Iloilo": [
      "Ajuy",
      "Alimodian",
      "Anilao",
      "Badiangan",
      "Balasan",
      "Banate",
      "Barotac Nuevo",
      "Barotac Viejo",
      "Batad",
      "Bingawan",
      "Cabatuan",
      "Calinog",
      "Carles",
      "City of Passi",
      "Concepcion",
      "Dingle",
      "Dueñas",
      "Dumangas",
      "Estancia",
      "Guimbal",
      "Igbaras",
      "Iloilo City",
      "Janiuay",
      "Lambunao",
      "Leganes",
      "Lemery",
      "Leon",
      "Maasin",
      "Miagao",
      "Mina",
      "New Lucena",
      "Oton",
      "Pavia",
      "Pototan",
      "San Dionisio",
      "San Enrique",
      "San Joaquin",
      "San Miguel",
      "San Rafael",
      "Santa Barbara",
      "Sara",
      "Tigbauan",
      "Tubungan",
      "Zarraga"
    ],
    "Negros Occidental": [
      "Bacolod City",
      "Bago City",
      "Binalbagan",
      "Cadiz City",
      "Calatrava",
      "Candoni",
      "Cauayan",
      "Enrique B. Magalona (saravia)",
      "Escalante City",
      "Himamaylan City",
      "Hinigaran",
      "Hinoba-An (asia)",
      "Ilog",
      "Isabela",
      "Kabankalan City",
      "La Carlota City",
      "La Castellana",
      "Manapla",
      "Moises Padilla (magallon)",
      "Murcia",
      "Pontevedra",
      "Pulupandan",
      "Sagay City",
      "Salvador Benedicto",
      "San Carlos City",
      "San Enrique",
      "Silay City",
      "Sipalay City",
      "Talisay City",
      "Toboso",
      "Valladolid",
      "Victorias City"
    ]
  },
  "Region VII – Central Visayas": {
    "Bohol": [
      "Alburquerque",
      "Alicia",
      "Anda",
      "Antequera",
      "Baclayon",
      "Balilihan",
      "Batuan",
      "Bien Unido",
      "Bilar",
      "Buenavista",
      "Calape",
      "Candijay",
      "Carmen",
      "Catigbian",
      "Clarin",
      "Corella",
      "Cortes",
      "Dagohoy",
      "Danao",
      "Dauis",
      "Dimiao",
      "Duero",
      "Garcia Hernandez",
      "Guindulman",
      "Inabanga",
      "Jagna",
      "Jetafe",
      "Lila",
      "Loay",
      "Loboc",
      "Loon",
      "Mabini",
      "Maribojoc",
      "Panglao",
      "Pilar",
      "Pres. Carlos P. Garcia (pitogo)",
      "Sagbayan (borja)",
      "San Isidro",
      "San Miguel",
      "Sevilla",
      "Sierra Bullones",
      "Sikatuna",
      "Tagbilaran City",
      "Talibon",
      "Trinidad",
      "Tubigon",
      "Ubay",
      "Valencia"
    ],
    "Cebu": [
      "Alcantara",
      "Alcoy",
      "Alegria",
      "Aloguinsan",
      "Argao",
      "Asturias",
      "Badian",
      "Balamban",
      "Bantayan",
      "Barili",
      "Bogo City",
      "Boljoon",
      "Borbon",
      "Carcar City",
      "Carmen",
      "Catmon",
      "Cebu City",
      "Compostela",
      "Consolacion",
      "Cordoba",
      "Daanbantayan",
      "Dalaguete",
      "Danao City",
      "Dumanjug",
      "Ginatilan",
      "Lapu-Lapu City (opon)",
      "Liloan",
      "Madridejos",
      "Malabuyoc",
      "Mandaue City",
      "Medellin",
      "Minglanilla",
      "Moalboal",
      "Naga City",
      "Oslob",
      "Pilar",
      "Pinamungahan",
      "Poro",
      "Ronda",
      "Samboan",
      "San Fernando",
      "San Francisco",
      "San Remigio",
      "Santa Fe",
      "Santander",
      "Sibonga",
      "Sogod",
      "Tabogon",
      "Tabuelan",
      "Talisay City",
      "Toledo City",
      "Tuburan",
      "Tudela"
    ],
    "Negros Oriental": [
      "Amlan (ayuquitan)",
      "Ayungon",
      "Bacong",
      "Bais City",
      "Basay",
      "Bayawan City (tulong)",
      "Bindoy (payabon)",
      "Canlaon City",
      "Dauin",
      "Dumaguete City",
      "Guihulngan City",
      "Jimalalud",
      "La Libertad",
      "Mabinay",
      "Manjuyod",
      "Pamplona",
      "San Jose",
      "Santa Catalina",
      "Siaton",
      "Sibulan",
      "Tanjay City",
      "Tayasan",
      "Valencia (luzurriaga)",
      "Vallehermoso",
      "Zamboanguita"
    ],
    "Siquijor": [
      "Enrique Villanueva",
      "Larena",
      "Lazi",
      "Maria",
      "San Juan",
      "Siquijor"
    ]
  },
  "Region VIII – Eastern Visayas": {
    "Biliran": [
      "Almeria",
      "Biliran",
      "Cabucgayan",
      "Caibiran",
      "Culaba",
      "Kawayan",
      "Maripipi",
      "Naval"
    ],
    "Eastern Samar": [
      "Arteche",
      "Balangiga",
      "Balangkayan",
      "Borongan City",
      "Can-Avid",
      "Dolores",
      "General Macarthur",
      "Giporlos",
      "Guiuan",
      "Hernani",
      "Jipapad",
      "Lawaan",
      "Llorente",
      "Maslog",
      "Maydolong",
      "Mercedes",
      "Oras",
      "Quinapondan",
      "Salcedo",
      "San Julian",
      "San Policarpo",
      "Sulat",
      "Taft"
    ],
    "Leyte": [
      "Abuyog",
      "Alangalang",
      "Albuera",
      "Babatngon",
      "Barugo",
      "Bato",
      "Baybay City",
      "Burauen",
      "Calubian",
      "Capoocan",
      "Carigara",
      "Dagami",
      "Dulag",
      "Hilongos",
      "Hindang",
      "Inopacan",
      "Isabel",
      "Jaro",
      "Javier (bugho)",
      "Julita",
      "Kananga",
      "La Paz",
      "Leyte",
      "Macarthur",
      "Mahaplag",
      "Matag-Ob",
      "Matalom",
      "Mayorga",
      "Merida",
      "Ormoc City",
      "Palo",
      "Palompon",
      "Pastrana",
      "San Isidro",
      "San Miguel",
      "Santa Fe",
      "Tabango",
      "Tabontabon",
      "Tacloban City",
      "Tanauan",
      "Tolosa",
      "Tunga",
      "Villaba"
    ],
    "Northern Samar": [
      "Allen",
      "Biri",
      "Bobon",
      "Capul",
      "Catarman",
      "Catubig",
      "Gamay",
      "Laoang",
      "Lapinig",
      "Las Navas",
      "Lavezares",
      "Lope de Vega",
      "Mapanas",
      "Mondragon",
      "Palapag",
      "Pambujan",
      "Rosario",
      "San Antonio",
      "San Isidro",
      "San Jose",
      "San Roque",
      "San Vicente",
      "Silvino Lobos",
      "Victoria"
    ],
    "Samar (western Samar)": [
      "Almagro",
      "Basey",
      "Calbayog City",
      "Calbiga",
      "Catbalogan City",
      "Daram",
      "Gandara",
      "Hinabangan",
      "Jiabong",
      "Marabut",
      "Matuguinao",
      "Motiong",
      "Pagsanghan",
      "Paranas (wright)",
      "Pinabacdao",
      "San Jorge",
      "San Jose de Buan",
      "San Sebastian",
      "Santa Margarita",
      "Santa Rita",
      "Santo Niño",
      "Tagapul-An",
      "Talalora",
      "Tarangnan",
      "Villareal",
      "Zumarraga"
    ],
    "Southern Leyte": [
      "Anahawan",
      "Bontoc",
      "Hinunangan",
      "Hinundayan",
      "Libagon",
      "Liloan",
      "Limasawa",
      "Maasin City",
      "Macrohon",
      "Malitbog",
      "Padre Burgos",
      "Pintuyan",
      "Saint Bernard",
      "San Francisco",
      "San Juan (cabalian)",
      "San Ricardo",
      "Silago",
      "Sogod",
      "Tomas Oppus"
    ]
  },
  "Region IX – Zamboanga Peninsula": {
    "Zamboanga Sibugay": [
      "Alicia",
      "Buug",
      "Diplahan",
      "Imelda",
      "Ipil",
      "Kabasalan",
      "Mabuhay",
      "Malangas",
      "Naga",
      "Olutanga",
      "Payao",
      "Roseller Lim",
      "Siay",
      "Talusan",
      "Titay",
      "Tungawan"
    ],
    "Zamboanga del Norte": [
      "Bacungan (leon T. Postigo)",
      "Baliguian",
      "Dapitan City",
      "Dipolog City",
      "Godod",
      "Gutalac",
      "Jose Dalman (ponot)",
      "Kalawit",
      "Katipunan",
      "La Libertad",
      "Labason",
      "Liloy",
      "Manukan",
      "Mutia",
      "Piñan (new Piñan)",
      "Polanco",
      "Pres. Manuel A. Roxas",
      "Rizal",
      "Salug",
      "Sergio Osmeña Sr.",
      "Siayan",
      "Sibuco",
      "Sibutad",
      "Sindangan",
      "Siocon",
      "Sirawai",
      "Tampilisan"
    ],
    "Zamboanga del Sur": [
      "Aurora",
      "Bayog",
      "Dimataling",
      "Dinas",
      "Dumalinao",
      "Dumingag",
      "Guipos",
      "Josefina",
      "Kumalarang",
      "Labangan",
      "Lakewood",
      "Lapuyan",
      "Mahayag",
      "Margosatubig",
      "Midsalip",
      "Molave",
      "Pagadian City",
      "Pitogo",
      "Ramon Magsaysay (liargo)",
      "San Miguel",
      "San Pablo",
      "Sominot (don Mariano Marcos)",
      "Tabina",
      "Tambulig",
      "Tigbao",
      "Tukuran",
      "Vincenzo A. Sagun",
      "Zamboanga City"
    ]
  },
  "Region X – Northern Mindanao": {
    "Bukidnon": [
      "Baungon",
      "Cabanglasan",
      "City of Malaybalay",
      "Damulog",
      "Dangcagan",
      "Don Carlos",
      "Impasug-Ong",
      "Kadingilan",
      "Kalilangan",
      "Kibawe",
      "Kitaotao",
      "Lantapan",
      "Libona",
      "Malitbog",
      "Manolo Fortich",
      "Maramag",
      "Pangantucan",
      "Quezon",
      "San Fernando",
      "Sumilao",
      "Talakag",
      "Valencia City"
    ],
    "Camiguin": [
      "Catarman",
      "Guinsiliban",
      "Mahinog",
      "Mambajao",
      "Sagay"
    ],
    "Lanao del Norte": [
      "Bacolod",
      "Baloi",
      "Baroy",
      "Iligan City",
      "Kapatagan",
      "Kauswagan",
      "Kolambugan",
      "Lala",
      "Linamon",
      "Magsaysay",
      "Maigo",
      "Matungao",
      "Munai",
      "Nunungan",
      "Pantao Ragat",
      "Pantar",
      "Poona Piagapo",
      "Salvador",
      "Sapad",
      "Sultan Naga Dimaporo (karomatan)",
      "Tagoloan",
      "Tangcal",
      "Tubod"
    ],
    "Misamis Occidental": [
      "Aloran",
      "Baliangao",
      "Bonifacio",
      "Calamba",
      "Clarin",
      "Concepcion",
      "Don Victoriano Chiongbian (don Mariano Marcos)",
      "Jimenez",
      "Lopez Jaena",
      "Oroquieta City",
      "Ozamis City",
      "Panaon",
      "Plaridel",
      "Sapang Dalaga",
      "Sinacaban",
      "Tangub City",
      "Tudela"
    ],
    "Misamis Oriental": [
      "Alubijid",
      "Balingasag",
      "Balingoan",
      "Binuangan",
      "Cagayan de Oro City",
      "Claveria",
      "El Salvador City",
      "Gingoog City",
      "Gitagum",
      "Initao",
      "Jasaan",
      "Kinoguitan",
      "Lagonglong",
      "Laguindingan",
      "Libertad",
      "Lugait",
      "Magsaysay (linugos)",
      "Manticao",
      "Medina",
      "Naawan",
      "Opol",
      "Salay",
      "Sugbongcogon",
      "Tagoloan",
      "Talisayan",
      "Villanueva"
    ]
  },
  "Region XI – Davao Region": {
    "Compostela Valley": [
      "Compostela",
      "Laak (san Vicente)",
      "Mabini (doña Alicia)",
      "Maco",
      "Maragusan (san Mariano)",
      "Mawab",
      "Monkayo",
      "Montevista",
      "Nabunturan",
      "New Bataan",
      "Pantukan"
    ],
    "Davao (davao del Norte)": [
      "Asuncion (saug)",
      "Braulio E. Dujali",
      "Carmen",
      "City of Tagum",
      "Island Garden City of Samal",
      "Kapalong",
      "New Corella",
      "Panabo City",
      "San Isidro",
      "Santo Tomas",
      "Talaingod"
    ],
    "Davao Occidental": [
      "Don Marcelino",
      "Jose Abad Santos (trinidad)",
      "Malita",
      "Santa Maria",
      "Sarangani"
    ],
    "Davao Oriental": [
      "Baganga",
      "Banaybanay",
      "Boston",
      "Caraga",
      "Cateel",
      "Governor Generoso",
      "Lupon",
      "Manay",
      "Mati City",
      "San Isidro",
      "Tarragona"
    ],
    "Davao del Sur": [
      "Bansalan",
      "Davao City",
      "Digos City",
      "Hagonoy",
      "Kiblawan",
      "Magsaysay",
      "Malalag",
      "Matanao",
      "Padada",
      "Santa Cruz",
      "Sulop"
    ]
  },
  "Region XII – SOCCSKSARGEN": {
    "Cotabato (north Cot.)": [
      "Alamada",
      "Aleosan",
      "Antipas",
      "Arakan",
      "Banisilan",
      "Carmen",
      "City of Kidapawan",
      "Kabacan",
      "Libungan",
      "M'lang",
      "Magpet",
      "Makilala",
      "Matalam",
      "Midsayap",
      "Pigkawayan",
      "Pikit",
      "President Roxas",
      "Tulunan"
    ],
    "Sarangani": [
      "Alabel",
      "Glan",
      "Kiamba",
      "Maasim",
      "Maitum",
      "Malapatan",
      "Malungon"
    ],
    "South Cotabato": [
      "Banga",
      "General Santos City (dadiangas)",
      "Koronadal City",
      "Lake Sebu",
      "Norala",
      "Polomolok",
      "Santo Niño",
      "Surallah",
      "T`boli",
      "Tampakan",
      "Tantangan",
      "Tupi"
    ],
    "Sultan Kudarat": [
      "Bagumbayan",
      "Columbio",
      "Esperanza",
      "Isulan",
      "Kalamansig",
      "Lambayong (mariano Marcos)",
      "Lebak",
      "Lutayan",
      "Palimbang",
      "President Quirino",
      "Sen. Ninoy Aquino",
      "Tacurong City"
    ]
  },
  "Region XIII – Caraga": {
    "Agusan del Norte": [
      "Buenavista",
      "Butuan City",
      "Cabadbaran City",
      "Carmen",
      "Jabonga",
      "Kitcharao",
      "Las Nieves",
      "Magallanes",
      "Nasipit",
      "Remedios T. Romualdez",
      "Santiago",
      "Tubay"
    ],
    "Agusan del Sur": [
      "Bayugan City",
      "Bunawan",
      "Esperanza",
      "La Paz",
      "Loreto",
      "Prosperidad",
      "Rosario",
      "San Francisco",
      "San Luis",
      "Santa Josefa",
      "Sibagat",
      "Talacogon",
      "Trento",
      "Veruela"
    ],
    "Dinagat Islands": [
      "Basilisa (rizal)",
      "Cagdianao",
      "Dinagat",
      "Libjo (albor)",
      "Loreto",
      "San Jose",
      "Tubajon"
    ],
    "Surigao del Norte": [
      "Alegria",
      "Bacuag",
      "Burgos",
      "Claver",
      "Dapa",
      "Del Carmen",
      "General Luna",
      "Gigaquit",
      "Mainit",
      "Malimono",
      "Pilar",
      "Placer",
      "San Benito",
      "San Francisco (anao-Aon)",
      "San Isidro",
      "Santa Monica (sapao)",
      "Sison",
      "Socorro",
      "Surigao City",
      "Tagana-An",
      "Tubod"
    ],
    "Surigao del Sur": [
      "Barobo",
      "Bayabas",
      "Bislig City",
      "Cagwait",
      "Cantilan",
      "Carmen",
      "Carrascal",
      "Cortes",
      "Hinatuan",
      "Lanuza",
      "Lianga",
      "Lingig",
      "Madrid",
      "Marihatag",
      "San Agustin",
      "San Miguel",
      "Tagbina",
      "Tago",
      "Tandag City"
    ]
  },
  "BARMM – Bangsamoro": {
    "Basilan": [
      "Akbar",
      "Al-Barka",
      "Hadji Mohammad Ajul",
      "Hadji Muhtamad",
      "Isabela City",
      "Lamitan City",
      "Lantawan",
      "Maluso",
      "Sumisip",
      "Tabuan-Lasa",
      "Tipo-Tipo",
      "Tuburan",
      "Ungkaya Pukan"
    ],
    "Lanao del Sur": [
      "Amai Manabilang (bumbaran)",
      "Bacolod-Kalawi (bacolod Grande)",
      "Balabagan",
      "Balindong (watu)",
      "Bayang",
      "Binidayan",
      "Buadiposo-Buntong",
      "Bubong",
      "Butig",
      "Calanogas",
      "Ditsaan-Ramain",
      "Ganassi",
      "Kapai",
      "Kapatagan",
      "Lumba-Bayabao (maguing)",
      "Lumbaca-Unayan",
      "Lumbatan",
      "Lumbayanague",
      "Madalum",
      "Madamba",
      "Maguing",
      "Malabang",
      "Marantao",
      "Marawi City",
      "Marogong",
      "Masiu",
      "Mulondo",
      "Pagayawan (tatarikan)",
      "Piagapo",
      "Picong (sultan Gumander)",
      "Poona Bayabao (gata)",
      "Pualas",
      "Saguiaran",
      "Sultan Dumalondong",
      "Tagoloan",
      "Tamparan",
      "Taraka",
      "Tubaran",
      "Tugaya",
      "Wao"
    ],
    "Maguindanao": [
      "Ampatuan",
      "Barira",
      "Buldon",
      "Buluan",
      "Cotabato City",
      "Datu Abdullah Sangki",
      "Datu Anggal Midtimbang",
      "Datu Blah T. Sinsuat",
      "Datu Hoffer Ampatuan",
      "Datu Odin Sinsuat (dinaig)",
      "Datu Paglas",
      "Datu Piang",
      "Datu Salibo",
      "Datu Saudi Ampatuan",
      "Datu Unsay",
      "Gen. S. K. Pendatun",
      "Guindulungan",
      "Kabuntalan (tumbao)",
      "Mamasapano",
      "Mangudadatu",
      "Matanog",
      "Northern Kabuntalan",
      "Pagagawan",
      "Pagalungan",
      "Paglat",
      "Pandag",
      "Parang",
      "Rajah Buayan",
      "Shariff Aguak (maganoy)",
      "Shariff Saydona Mustapha",
      "South Upi",
      "Sultan Kudarat (nuling)",
      "Sultan Mastura",
      "Sultan Sa Barongis (lambayong)",
      "Talayan",
      "Talitay",
      "Upi"
    ],
    "Sulu": [
      "Hadji Panglima Tahil (marunggas)",
      "Indanan",
      "Jolo",
      "Kalingalan Caluang",
      "Lugus",
      "Luuk",
      "Maimbung",
      "Old Panamao",
      "Omar",
      "Pandami",
      "Panglima Estino (new Panamao)",
      "Pangutaran",
      "Parang",
      "Pata",
      "Patikul",
      "Siasi",
      "Talipao",
      "Tapul",
      "Tongkil"
    ],
    "Tawi-Tawi": [
      "Bongao",
      "Languyan",
      "Mapun (cagayan de Tawi-Tawi)",
      "Panglima Sugala (balimbing)",
      "Sapa-Sapa",
      "Sibutu",
      "Simunul",
      "Sitangkai",
      "South Ubian",
      "Tandubas",
      "Turtle Islands"
    ]
  }
};

export const PH_REGIONS = Object.keys(PH_GEO);
export const provincesOf = (region) => Object.keys(PH_GEO[region] || {});
export const citiesOf = (region, province) => (PH_GEO[region] && PH_GEO[region][province]) || [];
